/**
 * Utility functions for detecting device capabilities and types
 */

/**
 * Detects if the current device is a mobile device
 * @returns true if the device is mobile, false otherwise
 */
export const isMobileDevice = (): boolean => {
  // Check for touch capability and screen size
  const hasTouchScreen =
    'ontouchstart' in window || navigator.maxTouchPoints > 0
  const isMobileUserAgent =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  const isMobileScreenSize = window.innerWidth <= 768

  return hasTouchScreen && (isMobileUserAgent || isMobileScreenSize)
}

/**
 * Detects if the device has camera capabilities
 * @returns true if camera is available, false otherwise
 */
export const hasCameraSupport = (): boolean => {
  return !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia)
}

/**
 * Detects if the current device is iOS
 * @returns true if iOS device, false otherwise
 */
export const isIOSDevice = (): boolean => {
  const iOSPlatforms = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ]

  return (
    iOSPlatforms.includes(navigator.platform) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document)
  )
}

/**
 * Detects if the current device is Android
 * @returns true if Android device, false otherwise
 */
export const isAndroidDevice = (): boolean => {
  return /Android/i.test(navigator.userAgent)
}
